import {config} from '@config';

import {domLoaded, getPreloadUrls} from '@helpers/dom';
import {sleep} from '@helpers/utils';
import {Time} from '@lib/Time';
import {StoreProvider} from '@lib/store/StoreProvider';
import {createApplicationState} from '@services/ApplicationState';
import {ComponentGenerator, ComponentMap} from '@services/ComponentGenerator';
import {MediaQuery} from '@services/MediaQuery';
// import {Navigation} from '@services/Navigation';
import {OrientationService} from '@services/OrientationService';
import {Preloader} from '@services/Preloader';

Time.create().start('prepare');

export const createApplicationInitializer = (componentMap: ComponentMap) => {
  const preloader = Preloader.create();
  const generator = new ComponentGenerator(componentMap);
  // const navigation = Navigation.create({generator, preloader});
  const appState = createApplicationState();
  const mediaQuery = MediaQuery.create(config.mediaQueryString);
  const orientationService = OrientationService.create();
  return {
    init: async () => {
      StoreProvider.create();

      // state の初期化
      mediaQuery.mode && appState.updateMediaQueryScreenMode(mediaQuery.mode);
      orientationService.orientation &&
        appState.updateOrientation(orientationService.orientation);

      // DOMのロード待ち
      await domLoaded();

      mediaQuery.onChange.connect((mode) => {
        appState.updateMediaQueryScreenMode(mode);
      });

      orientationService.onChange.connect((orientation) => {
        appState.updateOrientation(orientation);
      });

      generator.initialize();
      // navigation.start(config.navigationSwitchSelector);

      // TODO: script tag でobjectとかにしたほうがよい？
      const urls = getPreloadUrls();
      await preloader.load(urls);

      // splash screenを最低○秒見せたいので
      await sleep(
        config.initialPageIndicatorDuration -
          Time.create().getDuration('prepare'),
      );
      appState.updatePageIndicatorStatus('hide');
    },
  };
};
